import React from 'react';
import {Alert, Button} from 'react-bootstrap';

const headerPills = [
  'number',
  'lastname',
  'firstname',
  'street',
  'postalCode',
  'city',
  'memberWork'
];

const sampleCsv = [
  headerPills.join(';'),
  '000123;Meier;Anna;Hauptstr. 1;12345;Beispielstadt;Ja',
  '42;Schmidt;Tom;Bachweg 7;98765;Musterhausen;Nein'
].join('\n');

export const CsvFormatInfo: React.FC = () => {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(sampleCsv);
    } catch {
    }
  };

  return (
    <Alert
      variant="light"
      role="region"
      className="mb-4 shadow-sm"
      style={{
        borderLeft: '4px solid #0d6efd',
        background: '#f8fbff'
      }}
    >
      <div className="d-flex align-items-start justify-content-between">
        <div>
          <h5 className="mb-2 text-primary fw-semibold">Erwartetes CSV-Format</h5>
          <p className="mb-3" style={{color: '#000'}}>
            Bitte laden Sie eine CSV-Datei mit allen aktiven Mitgliedern hoch. Fangkarte entfernt automatisch alle
            Mitglieder die in Fangkarte existieren, jedoch nicht mehr in der CSV und legt neue Mitglieder an, die in der
            CSV existieren aber nicht in Fangkarte.

            Die Spalten müssen exakt wie folgt benannt sein:
          </p>

          <div className="d-flex flex-wrap gap-2 mb-3">
            {headerPills.map((h) => (
              <span
                key={h}
                className="badge rounded-pill text-bg-primary"
                style={{fontSize: 12, padding: '0.45rem 0.65rem'}}
              >
                {h}
              </span>
            ))}
          </div>

          <div
            className="mb-2"
            style={{
              background: '#f1f4f8',
              border: '1px solid #dde3ea',
              borderRadius: 8,
              padding: 12
            }}
          >
            <pre
              className="mb-0"
              style={{
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                fontFamily:
                  'ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,monospace',
                fontSize: 13,
                lineHeight: 1.45
              }}
            >
              {sampleCsv}
            </pre>
          </div>

            <div className={"mb-0 text-black"}>
              <p>
                Hinweis 1: In <code>memberWork</code> muss <strong>Ja</strong> oder{' '}
                <strong>Nein</strong> stehen.
              </p>
              <p>
                Hinweis 2: Die CSV-Datei muss in UTF-8 kodiert sein, damit Umlaute korrekt angezeigt werden.
              </p>
            </div>
        </div>

        <div className="ms-3">
          <Button
            size="sm"
            variant="outline-primary"
            onClick={copy}
            title="Beispiel in Zwischenablage kopieren"
          >
            Kopieren
          </Button>
        </div>
      </div>
    </Alert>
  );
};

export default CsvFormatInfo;
